// src/palette.ts
var palette = {
  // Primary tonal (coral-red)
  primary: {
    main: "#ad2f3c",
    container: "#ff6b74",
    onMain: "#ffffff",
    onContainer: "#6d0017",
    fixed: "#ffdad9",
    fixedDim: "#ffb3b3",
    onFixed: "#40000a",
    onFixedVariant: "#8c1427",
    inverse: "#ffb3b3"
  },
  // Secondary tonal (charcoal-indigo)
  secondary: {
    main: "#5a5d70",
    container: "#dee1f8",
    onMain: "#ffffff",
    onContainer: "#606376",
    fixed: "#dee1f8",
    fixedDim: "#c2c5db",
    onFixed: "#171b2b",
    onFixedVariant: "#424658"
  },
  // Tertiary tonal (green)
  tertiary: {
    main: "#006d41",
    container: "#00b26d",
    onMain: "#ffffff",
    onContainer: "#003c21",
    fixed: "#71fcaf",
    fixedDim: "#51df95",
    onFixed: "#002110",
    onFixedVariant: "#00522f"
  },
  // Error tonal
  error: {
    main: "#ba1a1a",
    container: "#ffdad6",
    onMain: "#ffffff",
    onContainer: "#93000a"
  },
  // Warning tonal (amber). Added because `warning` previously existed only as a
  // single foreground colour, with no container tone — so every surface that
  // needed a soft amber background hardcoded hex (#fef9c3 / #fef08a) straight
  // past the theme, and dark mode never got a matching pair.
  warning: {
    main: "#ca8a04",
    container: "#fef9c3",
    onMain: "#ffffff",
    onContainer: "#713f12",
    // Dark-mode counterparts — brighter accent on a deep, low-chroma surface.
    dark: "#fde047",
    darkContainer: "#42320c",
    onDark: "#713f12",
    onDarkContainer: "#fde68a"
  },
  // Neutral surfaces — toned down for subtlety
  neutral: {
    surface: "#fafafa",
    surfaceDim: "#e8e5e5",
    surfaceBright: "#fafafa",
    containerLowest: "#ffffff",
    containerLow: "#f7f6f6",
    container: "#f2f1f1",
    containerHigh: "#ececec",
    containerHighest: "#e6e5e5",
    onSurface: "#1c1b1f",
    onSurfaceVariant: "#5c5558",
    inverseSurface: "#322f34",
    inverseOnSurface: "#f5f2f5",
    outline: "#918a8d",
    outlineVariant: "#e8e3e4",
    surfaceTint: "#ad2f3c",
    surfaceVariant: "#f0eeee"
  },
  white: "#ffffff",
  black: "#000000",
  transparent: "transparent"
};

export {
  palette
};
